import React, { FC, Fragment } from 'react';
import { Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import { LeaderboardScoreFragment } from 'api';

interface IProps {
  change: LeaderboardScoreFragment['position_change'];
}

const Change: FC<IProps> = ({ change }) => {
  if (change === 0) {
    return <Fragment>--</Fragment>;
  }

  if (change > 0) {
    return (
      <Fragment>
        <ArrowUpwardIcon color="primary" sx={{ marginRight: theme => theme.spacing(0.5) }} />
        <Typography color="primary">{change}</Typography>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <ArrowDownwardIcon color="disabled" sx={{ marginRight: theme => theme.spacing(0.5) }} />
      <Typography color="textSecondary">{change}</Typography>
    </Fragment>
  );
};

export default Change;
